// extracted by mini-css-extract-plugin
module.exports = {"index":"Contract_index__1aCdT","cardBody":"Contract_cardBody__Sk1tK"};